import { getStorage, STORAGEKEY, setStorage } from "./storageCore";

// LOGGING TAGS
export const getEnabledLogTagsFromStorage = (): string[] => getStorage(STORAGEKEY.LOGGING_TAGS, [], "keepBetweenSessions");

export const setEnabledLogTagsInStorage = (tags: string[]) => setStorage(STORAGEKEY.LOGGING_TAGS, tags, "keepBetweenSessions");

export const enableLogTagInStorage = (tag: string) => {
   const current = new Set(getEnabledLogTagsFromStorage());
   current.add(tag);
   setEnabledLogTagsInStorage([...current]);
};

export const disableLogTagInStorage = (tag: string) => {
   const current = new Set(getEnabledLogTagsFromStorage());
   current.delete(tag);
   setEnabledLogTagsInStorage([...current]);
};

export const isLogTagEnabledInStorage = (tag: string): boolean => {
   const current = getEnabledLogTagsFromStorage();
   return current.includes(tag);
};

// CONFIGCAT LOGGING LEVEL
export const getConfigCatLogLevelFromStorage = (): string =>
   getStorage(STORAGEKEY.CONFIG_CAT_LOG_LEVEL, "-1", "keepBetweenSessions");

export const setConfigCatLogLevelInStorage = (newValue: string) =>
   setStorage(STORAGEKEY.CONFIG_CAT_LOG_LEVEL, newValue, "keepBetweenSessions");
